import { Injectable, EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class VehicleTransportService {
  is_display_vehile_transport_register_component = false;
  vehicleTransportUpdate = new EventEmitter<VehicleTransport>();

  downloadVehicleTransport = new EventEmitter<boolean>();

  private _vehicle_transport_data: VehicleTransport = null;
  constructor() {
  }

  set set_vehicle_transport_data(vehicle_transport) {
    this._vehicle_transport_data = vehicle_transport;
  }

  get get_vehicle_transport_data() {
    return this._vehicle_transport_data;
  }
}

export interface VehicleTransport {
  id: number;
  name: string;
}
